export const WON = 'Lead Won'
export const LOST = 'Lead Lost'
export const REJECTED = 'Lead Rejected'

export default {
  WON,
  LOST,
  REJECTED,
}
